module.exports = "<div class=\"dmattnt__container\">\n  <ol class=\"dmattnt__container breadcrumb\" ng-if=\"!$ctrl.onlyHome\">\n    <li  ng-repeat=\"step in $ctrl.steps track by step.name\" ng-class=\"{active: $last}\" ng-switch=\"$last || !!step.abstract\" class=\"ng-scope\">\n      <a ng-switch-when=\"false\" ui-sref=\"{{step.name}}\">{{step.data.label}}</a>\n      <span ng-switch-when=\"true\">{{step.data.label}}</span>\n    </li>\n  </ol>\n</div>\n<dmattnt-progress progress-disabled=\"!$ctrl.working\"></dmattnt-progress>";


//////////////////
// WEBPACK FOOTER
// ./src/modules/base/components/menu/menu.html
// module id = 301
// module chunks = 0